import React, { FC, useMemo } from "react";
import Head from "next/head";
import ResetCss from "components/front/layout/ResetCss";

const TITLE = "【特設ページ】絶頂1919人 「劇場版 生徒会役員共２」応援クラウドファンディング - アニメファンド（animefund）";

export const Sydm2LpHead: FC = () => {
  const robotsValue = useMemo(() => {
    return process.env.APP_ENV === "production" ? "all" : "noindex";
  }, []);
  return (
    <>
      <Head>
        <meta name="viewport" content="width=device-width,initial-scale=1,user-scalable=no" />
        <title>{TITLE}</title>
        <meta
          name="description"
          content="SYDファンの皆様に支えられ、「生徒会役員共」が再び劇場に帰ってきました！来る2021年1月1日元日、全国発射（ロードショー）に向けて、「劇場版 生徒会役員共２」を盛り上げるファン参加型のプロジェクトになります。"
        />
        <meta name="keywords" content="クラウドファンディング,資金調達,アニメファンド,animefund,アニメ,アニメーター,製作委員会,制作会社" />
        <link rel="canonical" href="https://animefund.com/lp/sydm2" />
        <meta property="og:title" content="【特設ページ】絶頂1919人 「劇場版 生徒会役員共２」応援クラウドファンディング" />
        <meta
          property="og:description"
          content="SYDファンの皆様に支えられ、「生徒会役員共」が再び劇場に帰ってきました！来る2021年1月1日元日、全国発射（ロードショー）に向けて、「劇場版 生徒会役員共２」を盛り上げるファン参加型のプロジェクトになります。"
        />
        <meta property="og:image" content="https://animefund.com/project-preview/1/1_main_20201028054736_1.jpg" />
        <meta property="og:url" content="https://animefund.com/lp/sydm2" />
        <meta property="og:site_name" content="アニメファンド" />
        <meta property="og:locale" content="ja_JP" />
        <meta property="og:type" content="article" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@animefund" />
        <meta property="fb:app_id" content="2809748165906745" />
        <meta name="robots" content={robotsValue} key="robots" />
      </Head>
      <ResetCss />
    </>
  );
};
